module.exports = __webpack_public_path__ + "img/j@3x.8292ce78.png";